import { render, staticRenderFns } from "./scenario-datatable.vue?vue&type=template&id=53b34024&scoped=true"
import script from "./scenario-datatable.vue?vue&type=script&lang=js"
export * from "./scenario-datatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b34024",
  null
  
)

export default component.exports